// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__w5sXF","logo":"footer_logo__XypVI","aTagLogo":"footer_aTagLogo__8pKtg","copycontainer":"footer_copycontainer__GbDfW","copyright":"footer_copyright__pJHGu"};